
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.223 5.763l1.181 1.823 2.567.979 1.384 3.276h7.376c.027.2.073.398.139.593l.525-.178.044-.015a2.487 2.487 0 01.127-1.914 2.49 2.49 0 011.443-1.265 2.529 2.529 0 011.937.137l.021-.041.251-.495a3.119 3.119 0 00-.931-.298l-.31-.948-2.047-2.333a.898.898 0 00-.586-.302l-.66-.066v-.642l1.398-.016a.145.145 0 00.114-.056l.1-.13a.146.146 0 00-.028-.207l-1.64-1.21a.363.363 0 00-.438-.012l-1.083.768a.65.65 0 00-.193.217l-.724-.256a.2.2 0 00-.145.373l.003.002.008.003 1.866.661a.2.2 0 01-.245.28l-.61-.215 1.05 1.386-.54 4.83h-2.609l-2.245-.006v-.334l2.155.004-.348-1.286.774-1.327a.517.517 0 00-.03-.567l-.51-.693a.518.518 0 00-.357-.208l-2.386-.277a1.169 1.169 0 01-.536-.203l-.168-.118a1.173 1.173 0 00-.588-.208l-4.273-.303a.378.378 0 00-.362.55l.128.247zM18.11 9.366a2.187 2.187 0 101.405 4.142 2.187 2.187 0 00-1.405-4.142zm1.52 1.793a.864.864 0 11-1.636.555.864.864 0 011.636-.555zm-12.373-.425a2.187 2.187 0 11-4.142 1.404 2.187 2.187 0 014.142-1.403zm-1.253.425a.864.864 0 10-1.636.555.864.864 0 001.636-.555z","fill":"currentColor"}})])
          )
        }
      }
    